<template>
  <!-- フッターエリア -->
  <footer class="l-footer" :class="nobg ? 'l-footer--nobg' : ''">
    <div class="l-footer-inner">
      <div>
        <div class="l-footer--left">
          <p class="l-footer__copyright">Copyright © 2018-{{ endYear }} SiGNITY Inc. All rights reserved</p>
        </div>
        <div class="l-footer--right">
          <span class="l-footer__policy"><a href="https://www.signity.jp/coins-tos/" target="_blank">利用規約</a></span>
          <span class="l-footer__policy"><a href="https://www.signity.jp/privacy-policy/" target="_blank">プライバシーポリシー</a></span>
        </div>
      </div>
    </div>
  </footer>
  <!-- /フッターエリア -->
</template>

<script>
export default {
  props: {
    nobg: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      endYear: null
    }
  },
  mounted: function() {
    const currentDate = new Date();
    this.endYear = currentDate.getFullYear();
  }
}
</script>
